import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { uploadMedia } from "../../core/media.core";
import { useTranslation } from "../../core/translation.core";
import ArrowUpTrayIcon from "../../icons/arrowUpTray.icon";
import LoadingOvalIcon from "../../icons/loadingOval.icon";

export default function UploadMediaForm() {
  const { register, handleSubmit } = useForm();
  const queryClient = useQueryClient();
  const { t, msg } = useTranslation();
  const [uploadingStatus, setUploadingStatus] = useState<"init" | "uploading" | "uploaded">("init");

  const onSubmit = async (data) => {
    setUploadingStatus("uploading");
    await uploadMedia(data.media, queryClient);
    setUploadingStatus("uploaded");
    queryClient.invalidateQueries({ queryKey: ["mediaList"] });

    setTimeout(() => {
      setUploadingStatus("init");
    }, 2000);
  };

  function btnText() {
    switch (uploadingStatus) {
      case "init":
        return t(msg.form.upload);
      case "uploaded":
        return t(msg.form.uploaded);
      case "uploading":
        return t(msg.form.uploading);
    }
  }

  return (
    <form id="mediaForm" onSubmit={handleSubmit(onSubmit)} className="flex flex-col md:flex-row gap-8 justify-between w-full">
      <div>
        <input type="file" className="" multiple {...register("media")} />
      </div>
      <div>
        <button
          id="upload-media-btn"
          type="submit"
          className="bg-her-dodgerblue text-white py-1 px-4 rounded-md flex flex-row gap-2 items-center"
        >
          {uploadingStatus === "uploading" && <LoadingOvalIcon className="w-5 h-5" />}
          {uploadingStatus === "init" && <ArrowUpTrayIcon className="w-5 h-5" />}
          {btnText()}
        </button>
      </div>
    </form>
  );
}
